<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <PrimaryButton
          x-small
          @click="viewAddress"
          v-if="params.context.parentComponent.permissions.view"
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-database-marker"
          iconClass=""
        >
        </PrimaryButton>
      </template>
      <span>View Address Location</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <SecondaryButton
          @click="viewItem"
          v-if="params.context.parentComponent.permissions.view"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-eye"
          iconClass=""
        >
        </SecondaryButton>
      </template>
      <span>View</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <PrimaryButton
          x-small
          @click="editItem"
          v-if="params.context.parentComponent.permissions.change"
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-pencil"
          iconClass=""
        >
        </PrimaryButton>
      </template>
      <span>Edit</span>
    </v-tooltip>
    <!-- <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <ErrorButton
          @click="viewStatistics"
          v-if="params?.context?.parentComponent?.permissions?.view"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-chart-histogram"
          iconClass=""
        >
        </ErrorButton>
      </template>
      <span>Statistics</span>
    </v-tooltip> -->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <WarningButton
          @click="viewLog"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-text-box"
          iconClass=""
          v-if="params.context.parentComponent.permissions.view"
        >
        </WarningButton>
      </template>
      <span>Logs</span>
    </v-tooltip>
  </div>
</template>

<script>
import ViewAddressLocation from "@/components/ModuleBasedComponents/CustomerAddress/ViewAddressLocation.vue";
export default {
  components: { ViewAddressLocation },
  methods: {
    editItem() {
      this.params.context.parentComponent.editCustomer(this.params.data.id);
    },
    viewItem() {
      this.params.context.parentComponent.viewCustomer(this.params.data.id);
    },
    viewAddress() {
      this.params.context.parentComponent.viewCustomerAddressLocation(this.params.data.id);
    },
    viewLog() {
      this.params.context.parentComponent.getCustomerAddressLogs(
        this.params.data.id
      );
    },
    viewStatistics() {
      this.$router.push({
        name: "customer-statistics",
        params: {
          id: this.params.data.id,
        },
      });
    },
  },
};
</script>

<style></style>
